import PropTypes from "prop-types"
import React, { useEffect, useRef,useState } from "react"

import downArrow_dark from "../../../../assets/common/downArrow_dark.svg"
import downArrow from "../../../../assets/common/downArrow_white.svg"

const DropDownButton = ({ label, subMenus, buttonWrapperClass, disbaled, isMenuPositionTop = false }) => {
    const [isSubListVisible, setisSubListVisible] = useState(false)
    const [isdarkArrow, setisdarkArrow] = useState(false)
    const [tabPressed, setTabPressed] = useState(false)
    const ref = useRef(null)
    const handleClickOutside = (event) => {
        if (ref.current && !ref.current.contains(event.target)) {
            setTabPressed(false)
            setisSubListVisible(false)
        }
    }
    useEffect(() => {
        document.addEventListener("click", handleClickOutside, true)
        return () => {
            document.removeEventListener("click", handleClickOutside, true)
        }
    }, [])
    return (
        <>
            <div className="relative" data-twe-dropdown-ref ref={ ref }>
                <button
                    className={ `${buttonWrapperClass} flex items-center rounded-full w-full 
                    bg-primary-100 text-white font-bold text-sm transition duration-150 
                    ease-in-out hover:bg-primary-150 hover:text-primary-50 focus:bg-primary-150 
                    focus:text-primary-50 active:bg-primary-600 motion-reduce:transition-none px-4 h-9` }
                    type="button"
                    id="dropdownMenuButton"
                    data-twe-dropdown-toggle-ref
                    aria-expanded="false"
                    data-twe-ripple-init
                    data-twe-ripple-color="light"
                    onBlur={ () => {
                        if(!tabPressed){
                            setisSubListVisible(false)
                            setisdarkArrow(!isdarkArrow)
                        }
                    } }
                    onMouseEnter={ () => {
                        setisdarkArrow(true)
                    } }
                    onMouseLeave={ () => {
                        if (!isSubListVisible) {
                            setisdarkArrow(false)
                        }
                    } }
                    onKeyDown={ (e) => {
                        e.currentTarget.focus()
                        if(e.key == "Tab"){
                            setTabPressed(true)
                            setisdarkArrow(false)
                        }
                    } }
                    onClick={ (e) => {
                        if (isSubListVisible === true) {
                            e.currentTarget.blur()
                            setisdarkArrow(true)
                        } else {
                            setisSubListVisible(!isSubListVisible)
                        }
                    } }
                    onFocus={ () => { if (isSubListVisible === true) { 
                        setisdarkArrow(false) } else { setisdarkArrow(true) } } }
                    disabled={ disbaled }
                >
                    { label }
                    <span className="ms-2 w-2 [&>svg]:h-5 [&>svg]:w-5">
                        <img
                            src={ isdarkArrow ? downArrow_dark : downArrow }
                            className={ isMenuPositionTop ? "rotate-180" : "" }
                            height={ "12px" }
                            width={ "12px" }
                            alt="dropdown arrow"
                        />
                    </span>
                </button>
                { subMenus && subMenus?.length > 0 && (
                    <ul
                        className={ `absolute z-[9] hover:block flex flex-col items-start ${isMenuPositionTop ? "bottom-[38px]" : "top-[38px]"}
                            overflow-hidden rounded-lg border border-lightGray bg-white py-[12px]
                            text-base right-0 ${isSubListVisible ? "block" : "hidden"}` }
                        aria-labelledby="dropdownMenuButton"
                        data-twe-dropdown-menu-ref
                    >
                        { subMenus?.map((menu, index) => {
                            return (
                                <>
                                    <li className={ `flex flex-col items-start 
                                        ${index + 1 < subMenus.length ? "border-b border-solid border-lightGray" : ""} 
                                        min-w-[205px]` }>
                                        <button
                                            className="block w-full items-start
                                            self-stretch whitespace-nowrap bg-white items-start 
                                            px-[16px] py-[8px] gap-[10px] font-normal text-secondary-50 
                                            text-left text-sm hover:bg-lighestgray 
                                            focus:bg-lighestgray active:lighestgray
                                            focus:outline-none active:no-underline text-left"
                                            type="button"
                                            data-twe-dropdown-item-ref
                                            onClick={ (e) => {
                                                menu.action(e)
                                            } }
                                        >
                                            { menu.displayName }
                                        </button>
                                    </li>
                                </>
                            )
                        }) }
                    </ul>
                ) }
            </div>
        </>
    )
}

DropDownButton.propTypes = {
    buttonWrapperClass: PropTypes.string,
    label: PropTypes.string.isRequired,
    subMenus: PropTypes.array
}

export default DropDownButton
